import React from 'react';
import {
  CheckCircleOutlined,
  EyeOutlined,
  CalculatorOutlined,
  LikeOutlined,
  EditOutlined,
  ArrowRightOutlined,
  WarningOutlined,
  CloseCircleOutlined,
  RobotOutlined,
  LockOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';

// Catálogo fijo de iconos de @ant-design/icons disponibles para
// "Iconografía de Seguimiento". Se guarda el nombre (value) en el backend
// y se resuelve aquí al componente correspondiente para seleccionarlo/mostrarlo.
// El `value` va en MAYÚSCULAS porque CustomModelSerializerMixin del backend
// aplica upper() a todo CharField al guardar — si se guardara en PascalCase
// aquí, dejaría de hacer match con lo que realmente queda en BD.
// Nota: @ant-design/icons no tiene un icono de "fantasma"; se usa
// RobotOutlined como el más cercano disponible (registro/entidad sin
// identificar).
export const ICONOS_DE_SEGUIMIENTO = [
  {
    value: 'CHECKCIRCLEOUTLINED', label: 'Conforme', Icon: CheckCircleOutlined, color: '#52c41a',
  },
  {
    value: 'EYEOUTLINED', label: 'Verificación', Icon: EyeOutlined, color: '#1890ff',
  },
  {
    value: 'CALCULATOROUTLINED', label: 'Cálculo', Icon: CalculatorOutlined, color: '#595959',
  },
  {
    value: 'LIKEOUTLINED', label: 'Correcto', Icon: LikeOutlined, color: '#1890ff',
  },
  {
    value: 'EDITOUTLINED', label: 'Modificar', Icon: EditOutlined, color: '#595959',
  },
  {
    value: 'ARROWRIGHTOUTLINED', label: 'Procedencia', Icon: ArrowRightOutlined, color: '#1890ff',
  },
  {
    value: 'WARNINGOUTLINED', label: 'Alerta', Icon: WarningOutlined, color: '#faad14',
  },
  {
    value: 'CLOSECIRCLEOUTLINED', label: 'Incorrecto', Icon: CloseCircleOutlined, color: '#f5222d',
  },
  {
    value: 'ROBOTOUTLINED', label: 'Registro sin identificar', Icon: RobotOutlined, color: '#1890ff',
  },
  {
    value: 'LOCKOUTLINED', label: 'Asegurado', Icon: LockOutlined, color: '#595959',
  },
  {
    value: 'CLOCKCIRCLEOUTLINED', label: 'Urgente', Icon: ClockCircleOutlined, color: '#595959',
  },
];

// Comparación case-insensitive como red de seguridad adicional (por si algún
// valor llega sin normalizar desde otro punto de entrada, ej. fixtures).
export const getIconoDeSeguimiento = (value) => (
  ICONOS_DE_SEGUIMIENTO.find((e) => e.value === value?.toUpperCase?.())
);

// eslint-disable-next-line react/prop-types
export function IconoDeSeguimiento({ name, style }) {
  const icono = getIconoDeSeguimiento(name);
  if (!icono) return null;
  const { Icon, color } = icono;
  return <Icon style={{ color, ...style }} />;
}

export default ICONOS_DE_SEGUIMIENTO;
